module.exports = __webpack_public_path__ + "img/vertical_6_1_8004.5d5d6b8c.png";